import React, { useEffect, useState } from "react";
import BreadcrumbItem from "../../shared/components/BreadcrumbItem";
import { Row, Col, Card } from "react-bootstrap";
import Widgets from "./components/widgets";
import { InstitutionService } from "../institutions/service";
import { handleError } from "../../shared/functions/handleError";
import { usePagination } from "../../shared/hooks/usePagination";
import { UserService } from "../users/service";
import { IncidentService } from "../incidents/service";
import { IIncident } from "../../shared/interfaces/incident/IIncident";
import IncidentList from "../incidents/components/List";
import { useIncidentsListWebSocket } from "../../shared/hooks/useWebSocket";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { t } = useTranslation();
  const [institutionsCount, setInstitutionsCount] = useState<number>(0);
  const [usersCount, setUsersCount] = useState<number>(0);
  const [incidentsCount, setIncidentsCount] = useState<number>(0);
  const [incidents, setIncidents] = useState<IIncident[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);

  const { pagination, changeFilterHandler } = usePagination({
    perPage: 10,
  });

  const fetchDashboardData = () => {
    InstitutionService.getAll(pagination)
      .then((response) => {
        setInstitutionsCount(response?.totalElements);
      })
      .catch(handleError);

    UserService.getAll(pagination)
      .then((response) => {
        setUsersCount(response?.totalElements);
      })
      .catch(handleError);

    IncidentService.getAll(pagination)
      .then((response) => {
        setIncidentsCount(response?.totalElements);
        setIncidents(response?.data || []);
        setTotalPages(response?.totalPages || 0);
      })
      .catch(handleError);
  };

  // Alerting is global (useIncidentAlerts); here we only refresh the list
  const handleIncidentNotification = () => {
    fetchDashboardData();
  };

  // Setup WebSocket subscription for incident notifications
  useIncidentsListWebSocket(handleIncidentNotification);

  useEffect(() => {
    fetchDashboardData();
  }, [pagination.page, pagination.size]);

  return (
    <React.Fragment>
      <BreadcrumbItem mainTitle={t("dashboard.title")} subTitle={t("dashboard.home")} />
      <Row>
        <Widgets
          institutionsCount={institutionsCount}
          usersCount={usersCount}
          incidentsCount={incidentsCount}
        />
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h5>{t("dashboard.recentIncidents")}</h5>
              <small className="text-muted">{t("dashboard.liveUpdates")}</small>
            </Card.Header>
            <Card.Body>
              <IncidentList
                incidents={incidents}
                pagination={pagination}
                totalPages={totalPages}
                handleUpdateList={fetchDashboardData}
                changeFilterHandler={changeFilterHandler}
                showActions={true}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard;
